import { RolodexEntryJson } from './rolodexEntries'

export enum RolodexFilterOp {
  EQUAL = '=',
  GREATER_THAN = '>',
  LESS_THAN = '<',
  GREATER_THAN_OR_EQUAL = '>=',
  LESS_THAN_OR_EQUAL = '<=',
  NOT_EQUAL = '!=',
  CONTAINS = 'contains',
  IN = 'in',
  NOT_IN = 'not_in',
  IS_NULL = 'is_null',
  NOT_NULL = 'not_null',
  TRUTHY = 'truthy',
  FALSY = 'falsy',
  NULL = 'null',
  REGEX = '~',
  NOT_REGEX = '!~',
}

/** A type representing filters to use when querying */
export type RolodexFilterType = {
  type?: string
  field?: string
  key?: string | null
  op?: RolodexFilterOp | string
  value?: string | string[] | number | number[] | null
  cast?: string
}

export type RolodexAuditLogObject = {
  [key: string]: RolodexAuditLogJson[]
}

export type RolodexAuditLogJson = {
  id: number
  object_id: string
  old_value: RolodexEntryJson
  new_value: RolodexEntryJson
  metadata: RolodexAuditLogMetadataJson
  timestamp: string
  user_id: string
}

export type RolodexAuditLogMetadataJson = {
  user_id: string
  user_name: string | undefined
  user_email: string
  transaction_id: string
  api_operation: string
}

/**
 * The JSON required to perform a Rolodex "patch" operation to modify access
 * restrictions on an entry
 */
export type RolodexAccessRestrictionPatchJson = {
  restriction: 'internal' | null
  entry_ids: string[]
}

/**
 * Rolodex stores files under an entry, and so a file path in Rolodex consists
 * of an entry ID and a file path.
 */
export type RolodexFilePath = {
  entry_id: string
  path: string
}

/**
 * A Rolodex file path, plus the content type ("image/jpeg", "text/csv", etc.)
 * and optional metadata fields returned by the rolodex file APIs.
 */
export type RolodexFileRef = RolodexFilePath & {
  content_type: string
  is_dir?: boolean
  size?: number
  md5_hash?: string
  created_at?: string
  updated_at?: string
  created_by?: string
  last_updated_by?: string
  generation?: number
  entry_type?: string
  tags?: Record<string, string>
  file_metadata?: Record<string, unknown>
  document_processing_status?: string
  document_processing_status_timestamp?: string
}

/**
 * A Rolodex file path, plus the signed URL used to download that file
 */
export type RolodexSignedURLResult = RolodexFilePath & {
  signed_url: string
}

export enum RolodexAdvancedFilterOperator {
  AND = 'and',
  OR = 'or',
}

export type RolodexAdvancedFilterType = {
  operator: RolodexAdvancedFilterOperator
  filters: (RolodexFilterType | RolodexAdvancedFilterType)[]
}
